namespace RioERP.Products {
    export interface ProductSpecificationsForm {
        ProductId: Serenity.LookupEditor;
        ProductSpecificationBookId: Serenity.LookupEditor;
        SpecificationName: Serenity.StringEditor;
        SpecificationCode: Serenity.IntegerEditor;
        HasBooks: Serenity.BooleanEditor;
        HasPendrive: Serenity.BooleanEditor;
        IsLive: Serenity.BooleanEditor;
        ProcessOrderOnPaid: Serenity.BooleanEditor;
        IsActive: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        Eopens: Serenity.EnumEditor;
        EWatchtime: Serenity.EnumEditor;
        EValidityType: Serenity.EnumEditor;
        EValidity: Serenity.EnumEditor;
        ValidTill: Serenity.DateEditor;
        AllowedDevice: Serenity.LookupEditor;
        Rioplay8ESubscriptionType: Serenity.EnumEditor;
        Rioplay8ValidityInDays: Serenity.IntegerEditor;
        Rioplay8ValidDate: Serenity.DateEditor;
        Rioplay8EViewsType: Serenity.EnumEditor;
        Rioplay8ViewsPerContent: Serenity.IntegerEditor;
        Rioplay8EWatchTimetype: Serenity.EnumEditor;
        Rioplay8WatchTime: Serenity.DecimalEditor;
        Rioplay8AllowedDevices: Serenity.StringEditor;
    }

    export class ProductSpecificationsForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductSpecifications';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductSpecificationsForm.init)  {
                ProductSpecificationsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.EnumEditor;
                var w5 = s.DateEditor;
                var w6 = s.DecimalEditor;

                Q.initFormType(ProductSpecificationsForm, [
                    'ProductId', w0,
                    'ProductSpecificationBookId', w0,
                    'SpecificationName', w1,
                    'SpecificationCode', w2,
                    'HasBooks', w3,
                    'HasPendrive', w3,
                    'IsLive', w3,
                    'ProcessOrderOnPaid', w3,
                    'IsActive', w3,
                    'HasCourier', w3,
                    'Eopens', w4,
                    'EWatchtime', w4,
                    'EValidityType', w4,
                    'EValidity', w4,
                    'ValidTill', w5,
                    'AllowedDevice', w0,
                    'Rioplay8ESubscriptionType', w4,
                    'Rioplay8ValidityInDays', w2,
                    'Rioplay8ValidDate', w5,
                    'Rioplay8EViewsType', w4,
                    'Rioplay8ViewsPerContent', w2,
                    'Rioplay8EWatchTimetype', w4,
                    'Rioplay8WatchTime', w6,
                    'Rioplay8AllowedDevices', w1
                ]);
            }
        }
    }
}
